import { ReactElement, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import translateYup from '../Helpers/Yup'

interface YupProviderProps {
  children: ReactElement,
}

export function YupProvider({ children }: YupProviderProps): ReactElement {
  const { i18n, t } = useTranslation()
  useEffect(
    () => {
      translateYup(t) // TODO: move `translateYup`'s code into this `useEffect` when all instances of `translateYup` have been removed
    },
    [i18n, t],
  )
  return children
}
